import {observer} from "mobx-react";
import {
    buildShippingConfigConstruct,
    displayShipmentProcessType,
    displayShipmentType,
    displayShippingDestinationType,
    ShipmentProcessType,
    ShipmentTypeWithoutPost,
    ShippingConfigConstruct,
} from "../../api";
import {FieldSelect} from "@kroschke/react-ui";
import {FormSection} from "./FormSection";
import {ShipmentProcessTypeDto, ShipmentTypeDto, ShippingDestinationTypeDto} from "../../api/fms";
import {useState} from "react";

interface ShippingOptionFormProps {
    disabled: boolean
    value: ShippingConfigConstruct
    clientOptions: OptionType[],
    processType: ShipmentProcessType,
    validationFor: (p: string) => string | undefined
    onBlur: () => any
    onChange: (value: ShippingConfigConstruct) => any
}
interface ShippingOptionTabsProps {
    disabled: boolean
    value: ShippingConfigConstruct
    clientOptions: OptionType[],
    validationFor: (p: string) => string | undefined
    onBlur: () => any
    onChange: (value: ShippingConfigConstruct) => any
}

interface OptionType {
    label: string,
    value: string
}

interface ConfigRowProps {
    disabled: boolean
    clientOptions: OptionType[],
    value: ShippingConfigConstruct
    type: ShipmentTypeWithoutPost
    destination: ShippingDestinationTypeDto
    process: ShipmentProcessTypeDto
    onBlur: () => any
    onChange: (value: ShippingConfigConstruct) => any
    validationFor: (p: string) => string | undefined
}

const ConfigRow = observer(function ConfigRow({
                                                  disabled,
                                                  clientOptions,
                                                  validationFor,
                                                  value,
                                                  process,
                                                  destination,
                                                  type,
                                                  onBlur,
                                                  onChange
                                              }: ConfigRowProps) {
    const shippingClientOptions = clientOptions
    const validation = validationFor(`items.${process}.${destination}.${type}`)
    const shippingClientId = value[process][destination][type]
    const valueOverride = Boolean(shippingClientId.defaultValue && shippingClientId.value && shippingClientId.defaultValue !== shippingClientId.value)
    const options = shippingClientOptions.map(e => {
        if (valueOverride && e.value === shippingClientId.defaultValue) {
            return {
                ...e,
                label: `Standard: ${e.label}`
            }
        }
        return e
    })

    return <div className={"columns"}>
        <div className={"column is-one-fifth"}>
            <label
                className={`label ${valueOverride ? 'has-text-success' : (shippingClientId.defaultValue ? 'has-text-grey-light' : '')}`}
            >{displayShipmentType(type)}</label>
        </div>
        <div className={"column"}>
            <FieldSelect
                disabled={disabled}
                label={'Versandmandant'}
                options={options}
                value={shippingClientId.value}
                required={true}
                help={validation}
                invalid={Boolean(validation)}
                onBlur={() => onBlur()}
                onChange={e => {
                    const v = buildShippingConfigConstruct(
                        value,
                        process,
                        destination,
                        type,
                        {
                            ...shippingClientId,
                            value: e
                        }
                    )
                    onChange(v)
                }}
            />
        </div>
    </div>
})

const ShippingConfigurationTabs = observer(function ShippingConfigurationTabs({
                                                                                                clientOptions,
                                                                                                disabled,
                                                                                                value,
                                                                                                validationFor,
                                                                                                onBlur,
                                                                                                onChange
                                                                                            }: ShippingOptionTabsProps) {

    const [processTab, setProcessTab] = useState<ShipmentProcessTypeDto>(ShipmentProcessTypeDto.REGULAR)
    const ALLOWED_PROCESS_TYPES = [ShipmentProcessTypeDto.REGULAR, ShipmentProcessTypeDto.MVR, ShipmentProcessTypeDto.MVR_ON]

    return <>
        <div style={{overflow: 'visible', padding: '1em'}}>
            <div style={{display: "flex"}}>
                {ALLOWED_PROCESS_TYPES.map(processType =>
                    <div style={{paddingRight: '1em'}} key={'shipping-configuration-' + processType}>
                        <button className={`button is-rounded is-small is-info 
                                ${processType === processTab ? '' : 'is-outlined'}`}
                                onClick={() => {
                                    setProcessTab(processType)
                                }}>{displayShipmentProcessType(processType)}
                        </button>
                    </div>
                )}
            </div>
            <ShippingConfigurationForm
                disabled={disabled}
                clientOptions={clientOptions}
                processType={processTab}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                validationFor={validationFor}
            />
        </div>
    </>
})


const ShippingConfigurationForm = observer(function ShippingConfigurationForm({
                                                                                        clientOptions,
                                                                                        disabled,
                                                                                        value,
                                                                                        processType,
                                                                                        validationFor,
                                                                                        onBlur,
                                                                                        onChange
                                                                                    }: ShippingOptionFormProps) {

    return <>
        <div style={{overflow: 'visible', padding: '1em'}}>
            {Object.keys(ShippingDestinationTypeDto)
                .map(e => e as ShippingDestinationTypeDto)
                .map((destination => <FormSection
                    key={destination}
                    label={displayShippingDestinationType(destination)}
                    children={
                        <>
                            {Object.keys(ShipmentTypeDto)
                                .map(e => e as ShipmentTypeDto)
                                .filter(e => e !== ShipmentTypeDto.POST)
                                .map(e => e as ShipmentTypeWithoutPost)
                                .map(type => <ConfigRow
                                    validationFor={validationFor}
                                    clientOptions={clientOptions}
                                    key={`${processType}-${destination}-${type}`}
                                    process={processType}
                                    destination={destination}
                                    value={value}
                                    type={type}
                                    disabled={disabled}
                                    onBlur={onBlur}
                                    onChange={(e) => onChange(e)}
                                />)}
                        </>
                    }
                />))}
        </div>
    </>
})
export {
    ShippingConfigurationTabs
}
